import React, { useEffect, useRef, useState } from "react";
import './sidebar.scss'
import { containsProfanities } from "../../../shared/utils/ContainsProfanity";

type EditableNameProps = {
    value: string;                 // e.g. resource.name
    isEditing: boolean;            // parent-controlled (toggle when user clicks Rename)
    maxLength?: number;

    className?: string;
    inputClassName?: string;

    onCommit: (nextValue: string) => void;
    onCancel: () => void;
    onStartEdit?: () => void;
};

const MemberRenameInput: React.FC<EditableNameProps> = ({
    value,
    isEditing,
    maxLength = 20,
    className = "rename-title",
    inputClassName = "",
    onCommit,
    onCancel,
    onStartEdit,
}) => {
    const [draft, setDraft] = useState(value);
    const [submitError, setSubmitError] = useState("");
    const prevValueRef = useRef(value);
    const inputRef = useRef<HTMLInputElement | null>(null);

    // Keep draft in sync when value changes (e.g. resource updates from server)
    useEffect(() => {
        setDraft(value);
        setSubmitError("");
        prevValueRef.current = value;
    }, [value]);

    // Focus/select when editing begins
    useEffect(() => {
        if (isEditing) {
            requestAnimationFrame(() => {
                inputRef.current?.focus();
                inputRef.current?.select();
            });
        }
    }, [isEditing]);

    const commit = () => {
        const next = draft.trim();

        if (!next) {
            setDraft(prevValueRef.current);
            setSubmitError("");
            onCancel();
            return;
        }

        if (next.includes(".")) {
            setDraft(prevValueRef.current);
            setSubmitError("");
            onCancel();
            return;
        }

        if (containsProfanities(next)) {
            setSubmitError("This name contains profanity.");
            return;
        }

        // Only commit if changed
        if (next !== prevValueRef.current) {
            setSubmitError("");
            onCommit(next);
            prevValueRef.current = next;
        } else {
            setSubmitError("");
            onCancel();
        }
    };




    const isDot = draft.trim().includes(".");
    const isEmpty = !draft;


    const issueMessage = submitError || (isDot || isEmpty ? 'Enter Valid name' : '')





    const cancel = () => {
        setDraft(prevValueRef.current);
        setSubmitError("");
        onCancel();
    };

    return (
        <div className={`${className} edit-title-sb`}>
            {isEditing ? (
                <div>
                    <input
                        ref={inputRef}
                        value={draft}
                        maxLength={maxLength}
                        className={inputClassName}
                        onChange={(e) => {
                            setDraft(e.target.value);
                            setSubmitError("");
                        }}
                        onBlur={commit}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") commit();
                            if (e.key === "Escape") cancel();
                        }}
                    />
                    <span className="rename-issue">{issueMessage}</span>
                </div>
            ) : (
                <p title={value} onClick={onStartEdit}>
                    {value}
                </p>
            )}
        </div>
    );
};

export default MemberRenameInput;
